export const isValidReason = (reason) => {
  if (reason.length < 1 || reason.length > 1000) return false;

  return /[\p{L}\p{N}\p{M}]+/u.test(reason);
};

export const ScoringPanelIndividualConfig = [
  { item: 'partyName', label: 'Name' },
  { item: 'customerRiskScore', label: 'Customer Risk Score' },
  { item: 'riskScoreHistory' },
  { item: 'manualRiskRating', label: 'Manual Risk Rating' },
  { item: 'customer_id', label: 'ID' },
  { item: 'gender', label: 'Gender' },
  { item: 'age', label: 'Age' },
  { item: 'nationality', label: 'Nationality' },
  { item: 'segmentName', label: 'Segment' },
  { item: 'customerOnboardDate', label: 'Customer Since' }
];

export const ScoringPanelCorporateConfig = [
  { item: 'partyName', label: 'Name' },
  { item: 'customerRiskScore', label: 'Customer Risk Score' },
  { item: 'riskScoreHistory' },
  { item: 'manualRiskRating', label: 'Manual Risk Rating' },
  { item: 'customer_id', label: 'ID' },
  { item: 'age', label: 'Age' },
  { item: 'segmentName', label: 'Segment' },
  { item: 'typeOfBusiness', label: 'Nature of Business' },
  { item: 'customerOnboardDate', label: 'Customer Since' }
];
